import { cdnUrl } from '@platform/media';
import type { ProductVariant } from '@/features/home/common';

/**
 * 브랜드 아이덴티티 단일 소스.
 * - 색상은 tailwind 토큰(shared.css --color-primary/brand-*)과 동일 값.
 *   className을 쓸 수 있으면 `bg-primary` 등 토큰을 우선 사용하고,
 *   인라인 style/canvas/gradient 등 className이 안 되는 곳에서만 BRAND.color 사용.
 */
export const BRAND = {
  name: 'HOWCOST',
  legalName: '(주)하우코스트',
  logoMark: 'H',
  color: '#219eea',
} as const;

/**
 * 구독 대상 액센트 — **개인=빨강 / 기업=파랑**.
 *
 * 적용 범위는 **홈 pricing 카드와 store 뿐**이다.
 *
 * ⚠️ 제품 상세 페이지에는 쓰지 않는다. 제품 브랜드 컬러와 hue 가 겹치기 때문이다:
 *      XCOST #156dec H=259.3  vs  business #1473E6 H=257.1
 *      AQC   #e4242e H= 25.6  vs  individual #FA0F00 H= 29.7
 *    제품 페이지에서 이 색을 쓰면 파란 면이 "XCOST"인지 "기업 플랜"인지 알 수 없다.
 *    그쪽은 제품이 색을 소유하고, 개인/기업 구분은 라벨과 채움/테두리로 준다.
 *    (features/products/common/sections/BottomCtaSection.tsx 참고)
 */
export const TARGET_ACCENT = {
  /** 흰 배경 대비 6.37:1 / 흰 글씨 올렸을 때 6.37:1 — 둘 다 AA 통과 */
  individual: { solid: '#C20000', onDark: '#FF8A6E' },
  /** 4.54:1 — AA 하한에 가깝다. 더 밝게 가지 말 것 */
  business: { solid: '#1473E6', onDark: '#7FB4FF' },
} as const;

export const BRAND_LOGO = {
  name: 'HOWCOST',
  nameKo: '하우코스트',
  svg: cdnUrl('/assets/ci/logo.svg')
}

export const BRAND_SYMBOL = {
  name: 'HOWCOST',
  nameKo: '하우코스트',
  svg: cdnUrl('/assets/ci/logo_symbol.svg')
}

export const BRAND_HEIGHT = {
  name: 'HOWCOST',
  nameKo: '하우코스트',
  svg: cdnUrl('/assets/ci/logo_height.svg')
}

export const PRODUCT_BI: Partial<Record<ProductVariant, { name: string; png: string }>> = {
  xcost: { name: 'XCOST PRO', png: cdnUrl('/assets/bi/xcost_pro.png') },
  aqc: { name: 'XPIXELS AQC', png: cdnUrl('/assets/bi/xpixels_aqc.png') },
  sqc: { name: 'XPIXELS SQC', png: cdnUrl('/assets/bi/xpixels_sqc.png') },
  eqc: { name: 'XPIXELS EQC', png: cdnUrl('/assets/bi/xpixels_eqc.png') },
  mqc: { name: 'XPIXELS MQC', png: cdnUrl('/assets/bi/xpixels_mqc.png') },
};
